import * as React from 'react'
import * as Redux from 'react-redux'

import * as api from '@owl-nest/api-client/latest'
import * as hooks from '@owl-nest/hooks'

import * as projectModel from '../../../../models/project'
import { type RootState } from '../../../../../reducers'
import * as UFE from '../../../../../UFE'

export function useLiveEventsSocket(): { liveEventsSocketReturn: hooks.SocketReturn } {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const userPermissions = project.permissions.self
  const userCantUpdate = !(userPermissions && userPermissions.includes(api.ProjectSelfPermission.UPDATE))

  const eventTypes: hooks.SocketEventType[] = [
    hooks.SocketEventType.VISITOR,
    hooks.SocketEventType.BACKERS,
    hooks.SocketEventType.NEWS_PUBLISHED,
    hooks.SocketEventType.ORDER,
  ]

  const liveEventsSocketReturn = hooks.useSocket(`${UFE.LIVE_PROJECT_URL}/${project.id}`)

  React.useEffect(() => {
    liveEventsSocketReturn.socketConnected && liveEventsSocketReturn.sendSubscribe(eventTypes)
  }, [liveEventsSocketReturn.socketConnected])

  React.useEffect(() => {
    if (userCantUpdate && liveEventsSocketReturn.socketConnected) {
      liveEventsSocketReturn.sendPublish({
        event_type: hooks.SocketEventType.VISITOR,
      })
    }
  }, [liveEventsSocketReturn.socketConnected])

  return { liveEventsSocketReturn }
}
